import http from './http.service';

class FormSurveyService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/events";
    }

    getDetails(eventId) {
        if (!eventId) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/${eventId}/details`);
    }

    getUpcoming() {
        return this.$http.get(`${this.baseUrl}/upcomingEvents`);
    }

    subscribeForEventNotification(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/subscribeForEventNotification`, model);
    }

     unsubscribeForEventNotification(eventId) {
        if (!eventId) {
            throw new Error('EventId is required');
        }

        return this.$http.delete(`${this.baseUrl}/unsubscribeForEventNotification`, { params: { eventId: eventId } });
    }
}

export default new FormSurveyService();
